import { render, staticRenderFns } from "./EditGroupModal.vue?vue&type=template&id=88f87648&scoped=true"
import script from "./EditGroupModal.vue?vue&type=script&lang=js"
export * from "./EditGroupModal.vue?vue&type=script&lang=js"
import style0 from "./EditGroupModal.vue?vue&type=style&index=0&id=88f87648&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f87648",
  null
  
)

export default component.exports